export const translations = {
  es: {
    title: "Proyectos",
    description: "Estos son los proyectos que he hecho por el momento. Me entusiasma mucho la idea de usar los conocimientos que adquiero en mis estudios, y más si los aplico en proyectos con una finalidad real que me desafíen y me enseñen aún más.",
    viewProject: "Ver Proyecto",
    viewRepository: "Ver Repositorio",
    viewNews: "Ver Noticia",
    projects: [
      {
        id: 1,
        title: "Proyecto ganador premiación Antel & Google - IA Tech Challenge 2025",
        date: "Julio 2025",
        status: "Desarrollo completado",
        description: "Primer lugar en el desafío **IMPO** (Dirección Nacional de Impresiones y Publicaciones Oficiales del Uruguay). El desafío consistía en crear una solución de inteligencia artificial usando herramientas de **Google Cloud** para abordar el problema de generar resúmenes de leyes (copetes) para su posterior publicación en el diario oficial y redes sociales. Nuestro producto consistió en un sistema de agentes que replica el trabajo de un equipo humano: un agente inicial, un agente crítico evaluador, y un agente refinador que usa la retroalimentación para mejorar el resultado. También incluimos una función de feedback para que los usuarios puedan proporcionar comentarios al sistema. Utilizamos tecnologías como **Firebase**, **Firestore**, **Cloud Storage**, y **ADK** para la comunicación entre agentes.",
        image: "/img/proyecto3impo.jpg",
        newsLink: "https://www.antel.com.uy/institucional/sala-de-prensa/eventos/premiacion-del-ia-tech-challenge-2025",
        hasNews: true
      },
      {
        id: 2,
        title: "Web Fullstack",
        date: "Abril 2025",
        status: "Desarrollo completo",
        description: "Web fullstack desarrollada para la empresa de maquinarias de construcción: Candelur S.A. Para el proyecto se utilizó **React** y **Tailwind CSS** en el front, y **Python**, **SQLite** y **FastAPI** en el back. Para mas detalles puedes visitar el repositorio en GitHub.",
        image: "/img/proyecto1cand.png",
        projectLink: "https://candelur.com.uy",
        repositoryLink: "https://github.com/inevaz/candelur.git",
        hasProject: true
      },
      {
        id: 3,
        title: "Proyecto ETL", 
        date: "Mayo 2025",
        status: "Desarollo completo",
        description: "Este es un pequeño proyecto que formó parte de un entregable del curso de Data Engineering de IBM. Se trata de un ETL sencillo usando los datos de una página de Wikipedia sobre el análisis de capitalización de mercado de bancos. El proyecto fue realizado en **Python**, usando **Pandas** y **NumPy** para el procesamiento de datos, **Requests** y **BeautifulSoup** para el web scraping, **SQLite3** para la base de datos, y **Streamlit** para la visualización de datos en la web (esto fue un agregado personal, ya que no era parte de la consigna). Se puede ver el código en el repositorio de GitHub.",
        image: "/img/proyecto2ETL.png",
        repositoryLink: "https://github.com/inevaz/ETL-Project-Largest-Banks-Market-Capitalization.git",
        hasProject: false
      }
      ,
      {
        id: 4,
        title: "Kepler Labelled Time-Series - Detección de Exoplanetas con ML",
        date: "Agosto 2025",
        status: "Desarrollo completado",
        description: "Desarrollé una pipeline de machine learning para clasificar candidatos a exoplanetas a partir de curvas de luz de Kepler (datos de la NASA). El proyecto incluye exploración de datos, comparación de modelos **(Random Forest, LightGBM, XGBoost)** y un workflow automatizado para resultados reproducibles. Trabajé en el manejo del desbalance de clases y en la evaluación del rendimiento de modelos orientados a descubrimientos astronómicos.",
  image: "/img/proyectoML-NASA.png",
  projectLink: "https://www.kaggle.com/datasets/keplersmachines/kepler-labelled-time-series-data",
  repositoryLink: "https://github.com/inevaz/Kepler-labelled-time-serie-ML-project",
        hasProject: true
      },
      {
        id: 5,
        title: "ToDo API con FastAPI y MCP",
        date: "Mayo 2025",
        status: "Desarrollo completado",
        description: "Aplicación ToDo construida con **Python** y el framework **FastAPI**. Diseñada con una arquitectura modular **Model-Context-Protocol (MCP)** que separa responsabilidades y facilita la extensibilidad. Usa **SQLite con SQLAlchemy** y está dockerizada para facilitar el despliegue. Ofrece una API RESTful con documentación interactiva y soporte CRUD para listas y tareas.",
          image: "/img/proyectoMCP-ToDo.png",
  repositoryLink: "https://github.com/inevaz/Proyecto_ToDo_MCP-FastAPI",
  // For ToDo project we want the primary red button to point to the repository
  primaryRepoButton: true,
        hasProject: true
      }
    ]
  },  en: {
    title: "Projects",
    description: "These are the projects I have done so far. I'm very excited about the idea of using the knowledge I acquire in my studies, especially when I apply it to projects with real purpose that challenge me and teach me even more.",
    viewProject: "View Project",
    viewRepository: "View Repository",
    viewNews: "View News",
    projects: [
      {
        id: 1,
        title: "Antel & Google Award Winner Project - AI Tech Challenge 2025",
        date: "July 2025",
        status: "Complete development",
        description: "First place in the **IMPO** (National Directorate of Official Printing and Publications of Uruguay) challenge. The challenge consisted of creating an artificial intelligence solution using **Google Cloud** tools to address the problem of generating law summaries (copetes) for later publication in the official journal and on social media. Our product consisted of a system of agents that replicates the work of a human team: an initial agent, a critical evaluator agent, and a refiner agent that uses feedback to improve the output. We also included a feedback feature, allowing users to provide comments to the system to further improve the final result. We used technologies like **Firebase**, **Firestore**, **Cloud Storage**, and **ADK** for the agents.",
        image: "/img/proyecto3impo.jpg",
        newsLink: "https://www.antel.com.uy/institucional/sala-de-prensa/eventos/premiacion-del-ia-tech-challenge-2025",
        hasNews: true
      },
      {
        id: 2,
        title: "Fullstack Web",
        date: "April 2025",
        status: "Complete development",
        description: "Fullstack web developed for the construction machinery company: Candelur S.A. For the project, **React** and **Tailwind CSS** were used on the front end, and **Python**, **SQLite** and **FastAPI** on the back end. For more details you can visit the repository on GitHub.",
        image: "/img/proyecto1cand.png",
        projectLink: "https://candelur.com.uy",
        repositoryLink: "https://github.com/inevaz/candelur.git",
        hasProject: true
      },
      {
        id: 3,
        title: "ETL Project",
        date: "May 2025", 
        status: "Complete development",
        description: "This is a small project that was part of a deliverable from IBM's Data Engineering course. It's a simple ETL using data from a Wikipedia page on market capitalization analysis of banks. The project was done in **Python**, using **Pandas** and **NumPy** for data processing, **Requests** and **BeautifulSoup** for web scraping, **SQLite3** for the database, and **Streamlit** for data visualization on the web (this was a personal addition, as it wasn't part of the assignment). You can see the code in the GitHub repository.",
        image: "/img/proyecto2ETL.png",
        repositoryLink: "https://github.com/inevaz/ETL-Project-Largest-Banks-Market-Capitalization.git",
        hasProject: false
      }
      ,
      {
        id: 4,
        title: "Kepler Labelled Time-Series - Exoplanet Detection with Machine Learning",
        date: "August 2025",
        status: "Complete development",
        description: "Developed a machine learning pipeline to classify exoplanet candidates from NASA Kepler light curve data. The project includes data exploration, feature engineering, model comparison **(Random Forest, LightGBM, XGBoost)**, and an automated workflow for reproducible results. Focused on handling class imbalance and evaluating model performance for astronomical discovery.",
  image: "/img/proyectoML-NASA.png",
  projectLink: "https://www.kaggle.com/datasets/keplersmachines/kepler-labelled-time-series-data",
  repositoryLink: "https://github.com/inevaz/Kepler-labelled-time-serie-ML-project",
        hasProject: true
      },
      {
        id: 5,
        title: "ToDo API with FastAPI and MCP",
        date: "May 2025",
        status: "Complete development",
        description: "A ToDo list application built with **Python** and the **FastAPI** framework. It is designed with a modular **Model-Context-Protocol (MCP)** architecture, which separates concerns and allows for extensibility. The application uses **SQLite with SQLAlchemy** for data persistence and is containerized using **Docker** for consistent deployment and execution. It provides a RESTful API with interactive documentation, supporting CRUD operations for lists and tasks.",
          image: "/img/proyectoMCP-ToDo.png",
  repositoryLink: "https://github.com/inevaz/Proyecto_ToDo_MCP-FastAPI",
  // For ToDo project we want the primary red button to point to the repository
  primaryRepoButton: true,
        hasProject: true
      }
    ]
  }
};
